import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";

export const ErrorItems = styled.ul`
  padding-left: ${tokens.spacing.s};
`;

export const ErrorItem = styled.li`
  margin: ${tokens.spacing.xxs} 0;
`;

export const EmailLink = styled.a`
  color: ${tokens.color.brand["600"]};
`;
